
import { computed, ref, inject, watch, useRoute, onMounted } from '@nuxtjs/composition-api';
import { storeToRefs } from 'pinia';
import { useChosenVariantDetailsStore } from '~/stores/useChosenVariantDetailsStore';
import useTracking from '~/composable/tracking/useTracking';
import useUtilities from '~/composable/useUtilities';
export default {
  props: {
    defaultInstallmentPeriod: {
      type: Number,
      default: null
    },
    skuInStock: {
      type: Boolean,
      default: null
    }
  },
  setup(props, { emit }) {
    const flipper = inject('flipper')
    const reveal = ref(false)
    const { track } = useTracking()
    const { formatPrice } = useUtilities()
    const route = useRoute()
    const categorySlug = route.value.params.categoryslug.toLowerCase()
    const chosenVariantDetailsStore = useChosenVariantDetailsStore()
    const {
      chosenChannel,
      productDetails
    } = storeToRefs(chosenVariantDetailsStore)
    const selected = ref(null)

    const installmentMatrix = computed(() => {
      let installments = []
      installments = chosenChannel.value?.installmentOptions || []
      if (installments.find(attr => attr.displayText === 'Kontant') === undefined) {
        installments.push({
          months: 0,
          amount: chosenChannel.value?.productBundlePrice?.productWithSubscriptionPrice,
          displayText: 'Kontant',
          subText: ''
        })
      }
      return installments
    })

    const selectedInstallment = computed(() => {
      const defaultInstallmentVal = installmentMatrix.value?.find(installment => installment.months === props.defaultInstallmentPeriod)
      if (selected.value === null || selected.value < 0) {
        if (defaultInstallmentVal !== undefined) {
          return defaultInstallmentVal
        }
        return installmentMatrix.value[0]
      }
      return installmentMatrix.value[selected.value]
    })

    const getLabel = (installment) => {
      if (!installment) { return ''; }
      return installment.months > 0 ? 'Afbetaling i ' + installment.months + ' mdr.' : installment.displayText
    }

    watch(selectedInstallment, () => {
      emitChosenInstallment()
    })

    const trackChange = (close = false) => {
      track('changeInstallment', { installment: selectedInstallment, label: getLabel(selectedInstallment.value), productDetails, chosenChannel, categorySlug, close })
    }


    const openFlipper = () => flipper.open(reveal)
    const closeFlipper = (close = false) => {
      flipper.close(reveal)
      trackChange(close)
    }
    const emitChosenInstallment = () => {
      selected.value = installmentMatrix.value?.indexOf(selectedInstallment.value)
      emit('installmentChosen', selectedInstallment.value)
    }
    onMounted(() => {
      emitChosenInstallment()
    })

    return {
      formatPrice,
      getLabel,
      openFlipper,
      closeFlipper,
      flipper,
      reveal,
      selected,
      selectedInstallment,
      installmentMatrix,
      chosenChannel,
      productDetails,
      selectedInstallmentMonths: computed(() => selectedInstallment.value?.months),
      selectedInstallmentAmount: computed(() => selectedInstallment.value?.amount),
      isCash: computed(() => chosenChannel.value?.channelKey === 'Cash')
    }
  }
}
